<template>
  <div>
    <div class="mt-4">SCHEDULES VIEW</div>
    <div v-for="i in 20" :key="i" class="bg-green-100 m-10">OPA {{ i }}</div>
  </div>
</template>
